import { render, staticRenderFns } from "./MunicipalitySelectionShow.vue?vue&type=template&id=6337556c&scoped=true&"
import script from "./MunicipalitySelectionShow.vue?vue&type=script&lang=ts&"
export * from "./MunicipalitySelectionShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6337556c",
  null
  
)

export default component.exports